import { createSlice } from "@reduxjs/toolkit";
import { initialPreferences } from "data/dropdowndData/firstFormData";

const initialState = {
  tags: initialPreferences,
};

const selectedFieldSlice = createSlice({
  name: "userFieldsSeleceted",
  initialState,
  reducers: {
    setFieldsData: (state, action) => {
      state.tags = action.payload;
    },

    resetFieldsData: (state) => {
      state.tags = initialPreferences; // back to default
    },
  },
});

export const { setFieldsData, resetFieldsData } = selectedFieldSlice.actions;

export default selectedFieldSlice;
